import { appNums } from "../common/nums/app_nums"
const { MIN_PASSWORD_LENGTH } = appNums

export const alerts = {
    passwordReset: {
        msg: "Woot! You have successfully updated your password.",
        class: "success",
        field: "",
    },

    forgotPassword: {
        msg: "Almost there. Go check your email!",
        class: "success",
        field: "",
    },

    forgotPasswordError: {
        msg: "Something went wrong. Please try again.",
        class: "danger",
        field: "",
    },

    "No account exists for supplied email.": {
        msg: "There's no account registered to this email",
        class: "danger",
        field: "",
    },

    "User already registered": {
        msg: "There's already an account registered to this email",
        class: "danger",
        field: "",
    },

    emailRequired: {
        msg: "Email Required",
        class: "danger",
        field: "",
    },

    validEmailRequired: {
        msg: "Valid Email Required",
        class: "danger",
        field: "",
    },

    passwordRequired: {
        msg: "Password Required",
        class: "danger",
        field: "",
    },

    passwordTooShort: {
        msg: `Please enter a password that is ${MIN_PASSWORD_LENGTH} characters or longer`,
        class: "danger",
        field: "",
    },

    currentRequired: {
        msg: "Please enter your current password",
        class: "danger",
        field: "",
    },

    incorrectPassword: {
        msg: "Incorrect Password. Try again.",
        class: "danger",
        field: "",
    },

    confirmRequired: {
        msg: "Passwords must match",
        class: "danger",
        field: "",
    },

    badResetToken: {
        msg:
            "This reset link is no longer valid :/ Please request another below",
        class: "danger",
        field: "",
    },

    notVerified: {
        msg:
            "Please take a moment to verify your account, by clicking the link in your email",
        class: "warning",
        field: "",
    },

    verified: {
        msg: "Your email was successfully verified!",
        class: "success",
        field: "",
    },

    invalidVerification: {
        msg:
            "This link has expired. Sign in and select 'Verify Email' from the 'Accounts' page for a new link",
        class: "danger",
        field: "",
    },

    inviteError: {
        msg:
            "This invite has already been accepted. Please sign in.",
        class: "danger",
        field: "",
    },

    joinedTeamLoggedIn: {
        msg: team =>
            `You have successfully joined team '${team}'. Head on over to your teams tab to check it out!`,
        class: "success",
        field: "",
    },

    joinedTeamLoggedOut: {
        msg: team =>
            `You have successfully joined team '${team}'. Log in and head to your teams tab to check it out!`,
        class: "success",
        field: "",
    },

    incorrectCurrentPassword: {
        msg: "Incorrect Current Password. Try again.",
        class: "danger",
        field: "",
    },

    passwordChanged: {
        msg: "Password successfully changed!",
        class: "success",
        field: "",
    },

    failProfileUpdate: {
        msg: "Something went wrong saving changes to profile",
        class: "danger",
        field: "",
    },

    successProfileUpdate: {
        msg: "Your profile has been updated",
        class: "success",
        field: "",
    },

    failAccountUpdate: {
        msg: "Something went wrong saving changes to account",
        class: "danger",
        field: "",
    },

    successAccountUpdate: {
        msg: "Your account has been updated",
        class: "success",
        field: "",
    },

    successResendVerification: {
        msg: email => `Your verification code was resent to ${email}`,
        class: "success",
        field: "",
    },

    failResendVerification: {
        msg: "There was a problem resending your verification code.",
        class: "danger",
        field: "",
    },

    failAccountVerification: {
        msg: "Your verification code is incorrect",
        class: "danger",
        field: "",
    },

    successAccountVerification: {
        msg: "Your account has been verified!",
        class: "success",
        field: "",
    },

    alreadyVerified: {
        msg: "Your account has already been verified, please sign in", 
        class: "success", 
        field: "",
    },

    agreeToTerms: {
        msg: "You must agree to terms before continuing", 
        class: "danger", 
        field: "",
    },

    failAgreeToTerms: {
        msg: "Something went wrong accepting terms", 
        class: "danger", 
        field: "",
    },
}



// WEBPACK FOOTER //
// ./src/util/alert_error_utils.js